// extracted by mini-css-extract-plugin
module.exports = {"body":"main_body_OiNYP","veticalPadding":"main_veticalPadding_2JTMc","horizontalPadding":"main_horizontalPadding_3TvEO","footer":"main_footer_3AyII"};